import { createSelector } from 'reselect';

const selectWebsocketDomain = (state) => state.websocket;

export default createSelector(selectWebsocketDomain, (state) => state.channelName);
